import { type ReactNode, createContext, useContext } from 'react';

import type { ResourceEditMode, SceneLayoutDeployTypeCode, SceneLayoutScene } from './types';

export interface SceneLayoutContextValue {
  deployTypeCode?: SceneLayoutDeployTypeCode;
  paymentTiming?: string;
  skuType?: 'fixed' | 'custom';
  scene?: SceneLayoutScene;
  resourceEditMode?: ResourceEditMode;
  presetConfigSnapshot?: Record<string, unknown>;
  /** SKU 创建页资源配置步骤启用模块勾选 */
  moduleSelectionEnabled?: boolean;
}

const SceneLayoutContext = createContext<SceneLayoutContextValue | null>(null);

export function SceneLayoutProvider({ value, children }: { value: SceneLayoutContextValue; children: ReactNode }) {
  return <SceneLayoutContext.Provider value={value}>{children}</SceneLayoutContext.Provider>;
}

export function useSceneLayoutContext(): SceneLayoutContextValue {
  return useContext(SceneLayoutContext) ?? {};
}
